import { render, staticRenderFns } from "./IngresoPresupuestarioDetallePage.vue?vue&type=template&id=350f9416"
import script from "./IngresoPresupuestarioDetallePage.js?vue&type=script&lang=js&external"
export * from "./IngresoPresupuestarioDetallePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports